"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./bigwig"));
__export(require("./loader"));
__export(require("./bam"));
//# sourceMappingURL=index.js.map